module.exports = __webpack_public_path__ + "assets/4d3b7779f0b92272a3bbcf5855cd3806.png";